
const TOUCH_ID_SCREENS = {
    TOUCH_ID_CTL_OPENED: 'thocu_id_ctl_opened',
    TOUCH_ID_CTL_CLOSED: 'thocu_id_ctl_closed'
};

export {TOUCH_ID_SCREENS};
